import InputNumberControl from '@controls/InputNumberControl';
import React from 'react';
import clsx from 'clsx';
import { IRatingScaleProps } from './IRatingScaleProps';
import Hint from '@atoms/Hint';

/**
 * Шкала по умолчанию 0..5
 * @param className
 * @param isEdit
 * @param methods
 * @param hint
 * @constructor
 */
export const RatingScaleDefault = ({ className, isEdit, methods, hint }: IRatingScaleProps) => {
    return (
        <>
            {hint && isEdit && (
                <div className={'offer-crit-details__hint'}>
                    <Hint title={hint} variant="blue" maxWidth="100%" />
                </div>
            )}
            <div className={clsx('offer-crit-rating-scale-default', className)}>
                <InputNumberControl
                    label="Балл"
                    name="offerCrit.score"
                    required={true}
                    readOnly={!isEdit}
                    disabled={!isEdit}
                    floatPoints={2}
                    min={0}
                    max={5}
                    formState={methods.formState}
                    control={methods.control}
                    rules={{ required: 'Обязательное поле' }}
                />
                <span className={'offer-crit-details__formula-text'}>×</span>
                <InputNumberControl
                    label="Вес"
                    name="weight"
                    required={true}
                    readOnly={true}
                    disabled={!isEdit}
                    floatPoints={4}
                    formState={methods.formState}
                    control={methods.control}
                    rules={{ required: 'Обязательное поле' }}
                />
                <span className={'offer-crit-details__formula-text'}>=</span>
                <InputNumberControl
                    label="Рейтинг"
                    name="offerCrit.rating"
                    required={true}
                    readOnly={true}
                    disabled={!isEdit}
                    floatPoints={4}
                    formState={methods.formState}
                    control={methods.control}
                    rules={{ required: 'Обязательное поле' }}
                />
            </div>
        </>
    );
};
